import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'Caricamento...',
    saving: 'Salvataggio...',
    save: 'Salva',
    back: 'Indietro',
    error: 'Errore',
    notSet: 'Non impostato',
    user: 'Utente',
    system: 'Sistema',
    copied: 'Copiato!',
    copy: 'Copia',
    cancel: 'Annulla',
    creating: 'Creazione...',
    processing: 'Elaborazione...',
    you: 'Tu',
    stars: 'Stars',
    seeAll: 'Vedi tutto',
    filter: 'Filtra',
    amount: 'Importo',
    date: 'Data',
    details: 'Dettagli',
    mustBeLoggedIn: 'Devi effettuare l\'accesso',
    daysShort: 'g',
    hoursShort: 'h',
    minutesShort: 'min',
    justNow: 'Proprio ora',
    noTitle: 'Senza titolo',
    payment: 'pagamento',
    payments: 'pagamenti',
  },
  layout: {
    dashboard: 'Dashboard',
    invoices: 'Fatture',
    ledger: 'Registro',
    withdraws: 'Prelievi',
    redirects: 'Reindirizzamenti',
    settings: 'Impostazioni',
    admin: 'Admin',
    profile: 'Profilo',
    logout: 'Esci',
    tonConfigured: 'TON configurato',
    configureTon: 'Configura TON',
    tonNotConfigured: 'Indirizzo TON non configurato',
    active: 'Attivo',
    walletConnect: 'Collega wallet',
    walletTitle: 'Collega il tuo wallet TON',
    walletSubtitle: 'Inserisci l’indirizzo TON che riceverà i tuoi prelievi.',
    walletConnectedTitle: 'Wallet collegato',
    walletConnectedSubtitle: 'I tuoi prelievi saranno inviati a questo indirizzo.',
    walletCurrentAddress: 'Indirizzo collegato',
    walletAddressLabel: 'Indirizzo TON',
    walletHint: 'Formato user-friendly (EQ… / UQ…) o raw (0:…) accettato.',
    walletInvalidAddress: 'Indirizzo TON non valido',
    walletUpdate: 'Aggiorna indirizzo',
    walletChangeAddress: 'Cambia indirizzo',
    walletDisconnect: 'Scollega',
    walletDisconnectConfirmTitle: 'Scollegare il wallet?',
    walletDisconnectConfirmBody: 'Non potrai richiedere prelievi finché non colleghi un nuovo indirizzo.',
    walletSaved: 'Wallet collegato con successo',
    walletDisconnected: 'Wallet scollegato',
    newPaymentLink: 'Nuovo link di pagamento',
    openBot: 'Bot Telegram',
    helpCenter: 'Centro assistenza',
  },
  login: {
    seoTitle: 'Accedi | Piattaforma di pagamento Telegram Stars',
    seoDescription: 'Accedi al tuo account Telegram Stars Payment Platform',
    signIn: 'Accedi',
    signUp: 'Registrati',
    email: 'Email',
    password: 'Password',
    displayNameOptional: 'Nome visualizzato (opzionale)',
    displayNamePlaceholder: 'Il tuo nome',
    emailPlaceholder: 'tua@email.com',
    signInButton: 'Accedi',
    signUpButton: 'Registrati',
    signInWithGoogle: 'Accedi con Google',
    or: 'OPPURE',
    welcome: 'Benvenuto',
    subtitle: 'Accedi o crea un account per iniziare',
    minPasswordHint: 'Minimo 6 caratteri',
    tipTelegram: '💡 Suggerimento: puoi collegare il tuo account Telegram nelle impostazioni dopo la registrazione',
    continueWithTelegram: 'Continua con Telegram',
    telegramAuthError: 'Accesso con Telegram non riuscito. Riprova.',
    featureInstant: 'Creazione account istantanea',
    featureManage: 'Gestisci i tuoi pagamenti Telegram Stars',
    featureWithdraw: 'Preleva i tuoi fondi in TON',
    emailRequired: 'Inserisci la tua email',
    emailInvalid: 'Formato email non valido',
    passwordRequired: 'Inserisci la tua password',
    passwordRequiredSignup: 'Inserisci una password',
    passwordMinLength: 'La password deve contenere almeno 6 caratteri',
    genericError: 'Si è verificato un errore',
    recaptchaFailed: 'Verifica reCAPTCHA fallita. Riprova.',
    invalidCredentials: 'Email o password errati. Se non hai ancora un account, creane uno nella scheda «Registrati».',
    wrongPassword: 'Password errata. Controlla la password.',
    tooManyAttempts: 'Troppi tentativi. Riprova più tardi.',
    accountDisabled: 'Questo account è stato disabilitato. Contatta il supporto.',
    authNotEnabled: 'L\'autenticazione email/password non è attiva. Controlla la configurazione Firebase.',
    emailInUse: 'Questa email è già in uso. Accedi con questa email.',
    googleAuthError: 'Errore durante l\'autenticazione Google',
    popupClosed: 'Il popup è stato chiuso. Riprova.',
    popupBlocked: 'Il popup è stato bloccato. Consenti i popup e riprova.',
    popupCancelled: 'È consentita una sola richiesta popup alla volta.',
  },
  dashboard: {
    loading: 'Caricamento dashboard...',
    overallSummary: 'Riepilogo generale',
    lastMonth: 'Mese scorso',
    lastWeek: 'Settimana scorsa',
    lastYear: 'Anno scorso',
    balance: 'Saldo',
    available: 'Disponibile',
    totalEarned: 'Totale guadagnato',
    fromLastMonth: 'rispetto al mese scorso',
    recentPayments: 'Pagamenti recenti',
    last7days: 'Ultimi 7 giorni',
    last30days: 'Ultimi 30 giorni',
    quickActions: 'Azioni rapide',
    createLink: 'Crea link',
    createLinkDesc: 'Genera un nuovo link di pagamento',
    withdraw: 'Preleva',
    withdrawDesc: 'Preleva i tuoi Stars in TON',
    invoices: 'Fatture',
    invoicesDesc: 'Visualizza cronologia pagamenti',
    ledger: 'Registro',
    ledgerDesc: 'Visualizza tutte le transazioni',
    recentActivity: 'Attività recente',
    noRecentActivity: 'Nessuna attività recente',
    mostRecent: 'Più recenti',
    noRecentInvoices: 'Nessuna fattura recente',
    allInvoices: 'Tutte le fatture',
    paymentReceived: 'Pagamento ricevuto: {title}',
    withdrawalRequested: 'Prelievo richiesto: {amount} {suffix}',
    transaction: 'Transazione: {amount} {suffix}',
    invoiceLabel: 'Fattura #{id}',
    failedLoadBalance: 'Impossibile caricare il saldo',
    chartAmount: 'Importo',
  },
  invoices: {
    loading: 'Caricamento...',
    allInvoices: 'Tutte le fatture',
    paid: 'Pagate',
    sent: 'Inviate',
    created: 'Create',
    expired: 'Scadute',
    filter: 'Filtra',
    createInvoice: '+ Crea fattura',
    noInvoices: 'Nessuna fattura trovata',
    relatedTo: 'Relativo a:',
    paymentMode: 'Pagamento {mode}',
    copyLink: 'Copia link',
    copyLinkTitle: 'Copia link fattura',
    linkNotAvailable: 'Link fattura non disponibile',
    linkCopied: 'Link fattura copiato negli appunti!',
    copyFailed: 'Impossibile copiare il link',
    failedLoad: 'Impossibile caricare le fatture',
    statusPaid: 'pagata',
    statusSent: 'inviata',
    statusCreated: 'creata',
    statusExpired: 'scaduta',
    typeSingleUse: 'uso singolo',
    typeRecurring: 'ricorrente',
  },
  createInvoice: {
    back: 'Indietro',
    title: 'Crea un link di pagamento',
    subtitle: 'Genera un nuovo link di pagamento in pochi secondi',
    successTitle: 'Link di pagamento creato!',
    successSubtitle: 'Il tuo link di pagamento è pronto per essere condiviso',
    paymentLink: 'Link di pagamento:',
    integrationTitle: 'Integra questo link sul tuo sito',
    integrationDesc: 'Il nostro bot Telegram ti guida passo dopo passo (API, pulsante HTML, reindirizzamenti).',
    openTutorial: 'Apri tutorial',
    testLink: 'Testa link',
    viewInvoices: 'Visualizza le mie fatture',
    createNew: 'Crea un nuovo link',
    shareTelegram: 'Condividi su Telegram',
    paymentMode: 'Modalità di pagamento',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Importo (intero)',
    amountDecimal: 'Importo (decimale)',
    amountRequired: 'Inserisci un importo',
    amountIntegerError: 'L\'importo deve essere un intero maggiore di 0',
    amountNoDecimals: 'L\'importo in Stars deve essere un intero (senza decimali)',
    amountMustBeInteger: 'L\'importo in Stars deve essere un intero',
    amountGreaterThanZero: 'L\'importo deve essere maggiore di 0',
    titleOptional: 'Titolo (opzionale)',
    titlePlaceholder: 'Titolo pagamento (es.: Pagamento servizi)',
    descriptionOptional: 'Descrizione (opzionale)',
    descriptionPlaceholder: 'Descrizione dettagliata del pagamento...',
    singleUse: 'Link monouso',
    singleUseTooltip: 'Se attivato, questo link può essere usato una sola volta. Una volta pagato, non sarà più valido.',
    createLink: 'Crea link',
    cancel: 'Annulla',
    invalidAmount: 'Importo non valido',
    starsMustBeInteger: 'L\'importo deve essere un intero per Stars',
    createError: 'Errore nella creazione della fattura',
  },
  ledger: {
    title: 'Registro',
    typeColumn: 'Tipo',
    description: 'Cronologia completa di tutte le tue transazioni',
    loading: 'Caricamento...',
    noEntries: 'Nessuna transazione al momento.',
    typePayment: 'Pagamento',
    typeFee: 'Commissione',
    typeNetPayment: 'Pagamento netto',
    typeWithdrawal: 'Prelievo',
    typeAdjustment: 'Rettifica',
    amountStars: 'Importo (Stars)',
    invoiceDetail: 'Fattura: {title} ({amount} Stars)',
    paidBy: 'Pagato da: {payer}',
    payerId: '(ID: {id})',
    withdrawDetail: 'Prelievo: {amount} Stars (Stato: {status})',
    failedLoad: 'Impossibile caricare il registro',
  },
  withdraws: {
    title: 'Le mie richieste di prelievo',
    newRequest: '+ Nuova richiesta',
    totalLedger: 'Totale registro',
    available: 'Disponibile',
    pendingWithdrawals: 'Prelievi in sospeso',
    hold21days: 'Blocco 21 giorni',
    payoutNote: 'I pagamenti sono elaborati manualmente da un admin. Si applica una commissione del 3% al prelievo.',
    forecastTitle: 'Previsione prelievi',
    loadingForecast: 'Caricamento previsione...',
    noForecast: 'Nessuna data di prelievo imminente',
    paymentsCount: '({count} pagamenti)',
    noRequests: 'Nessuna richiesta di prelievo al momento.',
    createFirst: 'Crea la tua prima richiesta',
    amount: 'Importo:',
    destination: 'Destinazione:',
    processedOn: 'Elaborato il:',
    externalRef: 'Riferimento esterno:',
    errorLabel: 'Errore:',
    rejectionReason: 'Motivo del rifiuto:',
    failedLoad: 'Impossibile caricare i prelievi',
    loading: 'Caricamento...',
  },
  createWithdraw: {
    title: 'Richiedi un prelievo',
    balanceSource: 'Saldo (fonte: registro backend)',
    available: 'Disponibile: {amount} Stars',
    pending: 'Prelievi in sospeso: {amount} Stars',
    waiting: 'Blocco 21 giorni: {amount} Stars',
    minAndFee: 'Prelievo minimo: {min} Stars · Commissione piattaforma: 3% al pagamento (elaborazione manuale)',
    amountLabel: 'Importo (Stars)',
    minPlaceholder: 'Minimo: {min}',
    feeHint: 'Lordo: {gross} Stars · Commissione (3%): {fee} Stars · Ricevi: {net} Stars',
    useRegistered: 'Usa il mio indirizzo TON registrato',
    registeredAddress: 'Indirizzo registrato:',
    tonDestination: 'Indirizzo TON di destinazione',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Formato: EQ... o 0:... (base64 o hex)',
    createRequest: 'Crea richiesta',
    cancel: 'Annulla',
    creating: 'Creazione...',
    insufficientBalance: '⚠️ Saldo insufficiente per il prelievo (minimo: {min} Stars)',
    amountMustBeInteger: 'L\'importo deve essere un intero positivo',
    createError: 'Errore nella creazione della richiesta di prelievo',
  },
  redirects: {
    title: 'Link di reindirizzamento',
    description: 'Crea link brevi che reindirizzano a un URL a tua scelta. Condividere il link /r/tuo-slug invierà i visitatori all\'URL configurato.',
    newRedirect: 'Nuovo reindirizzamento',
    clicks: 'clic',
    unique: 'unici',
    links: 'link',
    modalTitle: 'Nuovo reindirizzamento',
    slugLabel: 'Slug (identificatore link)',
    slugRequired: 'Campo obbligatorio',
    slugPattern: 'Solo lettere, numeri, trattini e underscore',
    slugMax: 'Max 64 caratteri',
    slugReserved: 'Questo slug è riservato. Scegline un altro.',
    slugPlaceholder: 'es.: mio-sito',
    urlLabel: 'URL di destinazione',
    urlInvalid: 'URL non valido',
    urlHttpOnly: 'Sono accettati solo URL http e https.',
    urlTooLong: 'URL troppo lungo (max 2048 caratteri).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Crea reindirizzamento',
    loading: 'Caricamento…',
    empty: 'Nessun reindirizzamento. Clicca su «Nuovo reindirizzamento» per crearne uno.',
    copyLink: 'Copia link',
    linkCopied: 'Link copiato',
    deleteTitle: 'Eliminare questo reindirizzamento?',
    yes: 'Sì',
    no: 'No',
    delete: 'Elimina',
    totalClicks: 'Clic totali',
    uniqueClicks: 'Clic unici',
    avgClicks: 'Media clic/visitatore',
    loadError: 'Errore nel caricamento dei reindirizzamenti',
    createSuccess: 'Link di reindirizzamento creato',
    createError: 'Errore nella creazione del reindirizzamento',
    deleteSuccess: 'Reindirizzamento eliminato',
    deleteError: 'Errore nell\'eliminazione del reindirizzamento',
  },
  adminWithdraws: {
    title: 'Amministrazione - Richieste di prelievo',
    filterByStatus: 'Filtra per stato:',
    all: 'Tutti',
    noRequests: 'Nessuna richiesta per questo stato.',
    agent: 'Agente:',
    amount: 'Importo:',
    destination: 'Destinazione:',
    processedOn: 'Elaborato il:',
    externalRef: 'Rif. esterno:',
    errorLabel: 'Errore:',
    reason: 'Motivo:',
    approve: '✓ Approva',
    reject: '✗ Rifiuta',
    markPaid: '✓ Segna pagato',
    markFailed: '✗ Segna fallito',
    approveConfirm: 'Approvare questa richiesta di prelievo?',
    rejectPrompt: 'Motivo del rifiuto:',
    markPaidPrompt: 'Riferimento pagamento esterno (obbligatorio — hash tx TON, rif. bancario, ecc.):',
    markPaidRequired: 'externalRef è obbligatorio per confermare un pagamento manuale.',
    markFailedPrompt: 'Messaggio di errore:',
    approveError: 'Errore nell\'approvazione del prelievo',
    rejectError: 'Errore nel rifiuto del prelievo',
    updateError: 'Errore nell\'aggiornamento',
    failedLoad: 'Impossibile caricare i prelievi',
    notAuthenticated: 'Non autenticato',
    operationFailed: 'Operazione fallita',
    loading: 'Caricamento...',
  },
  redirectResolve: {
    missingSlug: 'Slug mancante',
    invalidLink: 'Link non valido',
    notFound: 'Link non trovato',
    notFoundTitle: 'Link non trovato',
    redirecting: 'Reindirizzamento...',
    redirectTitle: 'Reindirizzamento',
  },
  errorBoundary: {
    title: 'Si è verificato un errore',
    subtitle: 'Spiacenti, qualcosa è andato storto. Riprova.',
    goHome: 'Torna alla home',
    reload: 'Ricarica pagina',
    devDetails: 'Dettagli errore (solo dev):',
  },
};

export const settingsApp = {
  eyebrow: 'IMPOSTAZIONI',
  profile: 'Profilo',
  email: 'Email',
  telegramId: 'ID Telegram',
  notLinked: 'Non collegato',
  linking: 'Collegamento...',
  linkTelegram: 'Collega il mio account Telegram',
  openFromTelegram: '⚠️ Apri questa pagina da Telegram per collegare il tuo account',
  displayName: 'Nome visualizzato',
  displayNameHint: 'Il nome visualizzato viene impostato alla creazione dell\'account',
  withdrawal: 'Prelievo',
  tonAddress: 'Indirizzo TON di destinazione',
  tonAddressPlaceholder: 'EQAbc123... o 0:...',
  tonAddressHint: 'Questo indirizzo sarà usato di default per i tuoi prelievi',
  tonUpdated: 'Indirizzo TON aggiornato con successo',
  about: 'Informazioni',
  commission: 'Commissione piattaforma:',
  commissionValue: '3% su ogni pagamento',
  minWithdrawal: 'Prelievo minimo:',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Valuta Stars:',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp non disponibile. Apri questa pagina da Telegram.',
  telegramUserDataNotAvailable: 'Dati utente Telegram non disponibili.',
  telegramLinked: 'Account Telegram collegato con successo!',
  linkTelegramError: 'Errore nel collegamento dell\'account Telegram',
  updateError: 'Errore nell\'aggiornamento',
  mustBeLoggedIn: 'Devi effettuare l\'accesso',
};
